
(function roleModuleDefinition() {

    'use strict';

    angular.module('Role', ['ui.router', 'Config', 'Entities', 'ErrorsExtend', 'dndLists', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function roleConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('role-add', {
                    url: '/Role/Add',
                    templateUrl: config.resourceUrl('/views/role/add-modify.html'),
                    controller: 'RoleAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE WRITE')
                });

                $stateProvider.state('role-modify', {
                    url: '/Role/Modify/{id}',
                    templateUrl: config.resourceUrl('/views/role/add-modify.html'),
                    controller: 'RoleModifyController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE WRITE')
                });
              
                $stateProvider.state('role-find', {
                    url: '/Role/List',
                    templateUrl: config.resourceUrl('/views/role/list.html'),
                    controller: 'RoleFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE READ').or('ROLE WRITE')
                });

                $stateProvider.state('role-find-preselect', {
                    url: '/Role/List/{name}',
                    templateUrl: config.resourceUrl('/views/role/list.html'),
                    controller: 'RoleFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE READ').or('ROLE WRITE')
                });

                $stateProvider.state('role-detail', {
                    url: '/Role/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/role/detail.html'),
                    controller: 'RoleDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE READ').or('ROLE WRITE')
                });

                $stateProvider.state('role-functions', {
                    url: '/Role/AssociateFunctions/{id}',
                    templateUrl: config.resourceUrl('/views/role/associate.html'),
                    controller: 'RoleAssociateFunctionsController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE WRITE')
                });

                $stateProvider.state('role-document-types', {
                    url: '/Role/AssociateDocumentTypes/{id}/{name}',
                    templateUrl: config.resourceUrl('/views/role/associate.html'),
                    controller: 'RoleAssociateDocumentTypesController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE WRITE')
                });

                $stateProvider.state('role-container-types', {
                    url: '/Role/AssociateContainerTypes/{id}/{name}',
                    templateUrl: config.resourceUrl('/views/role/associate.html'),
                    controller: 'RoleAssociateContainerTypesController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE WRITE')
                });

                $stateProvider.state('role-clone', {
                    url: '/Role/Clone/{id}',
                    templateUrl: config.resourceUrl('/views/role/clone.html'),
                    controller: 'RoleCloneController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ROLE WRITE')
                });
            }
        ]);
})();